import clsx from 'clsx'
import React from 'react'

import { Text } from '@wartek-id/text-v1'

import { ABSENT_NOTE_MESSAGE } from 'app/KinerjaHarian/constants'

type Props = {
  checked: boolean
  onChange: (checked: boolean) => void
}

export default function AbsentConfirmationRadio({ checked, onChange }: Props) {
  return (
    <div className="space-y-4">
      <div
        className={clsx(
          'rounded-[6px] border-2 px-4 py-4',
          checked
            ? 'border-critical-default bg-surface-critical-default'
            : 'border-subdued'
        )}
      >
        <label className="flex cursor-pointer items-start gap-3">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            aria-labelledby="absent-confirmation-label"
            aria-describedby="absent-helper-text"
            className="sr-only peer"
          />
          <span className="mt-1 h-5 w-5 flex-shrink-0 rounded-full border-2 border-gray-300 peer-checked:border-critical-default peer-checked:bg-interactive-critical-default peer-focus:ring-2 peer-focus:ring-critical-default peer-focus:ring-offset-2 peer-focus:outline-none relative before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-2 before:h-2 before:rounded-full before:bg-white before:opacity-0 peer-checked:before:opacity-100" />

          <div className="flex-1 flex items-center justify-between gap-3">
            <div>
              <Text
                as="span"
                variant="heading-md"
                className={clsx(checked && 'text-critical')}
                id="absent-confirmation-label"
              >
                Tidak Hadir
              </Text>

              <Text id="absent-helper-text">
                Klik jika Anda tidak hadir pada tanggal yang dipilih karena
                libur, cuti, atau lainnya.
              </Text>
            </div>

            {checked ? (
              <Text
                as="span"
                color="critical"
                className="rounded-[6px] bg-critical-50 px-3 py-1"
              >
                Dipilih
              </Text>
            ) : null}
          </div>
        </label>
      </div>

      {checked ? (
        <div
          className="rounded-[6px] border border-critical-default bg-surface-critical-default px-4 py-3"
          role="alert"
          aria-live="polite"
        >
          <Text color="critical">{ABSENT_NOTE_MESSAGE}</Text>
        </div>
      ) : null}
    </div>
  )
}
